<template>
  <div class="page page-ciencias">
    <Header />
    <vue-headful
      title="Brincando Com Ciências | Ensino Fundamental - Anos Iniciais | Editora do Brasil"
      description="Brincando Com Ciências | Ensino Fundamental - Anos Iniciais | Editora do Brasil"
    />
    <section class="banner">
      <b-container class="text-center">
        <div class="banner-img">
          <div class="banner-btn" align-content="center">
            <b-button
              href="https://editoradobrasil.com.br/faleconosco/"
              target="_blank"
            >DÚVIDAS? FALE CONOSCO</b-button>
          </div>
          <img class="img-fluid" alt src="../../assets/anos-iniciais/ciencias/bg-ciencias.png" />
        </div>
      </b-container>
    </section>
    <section class="carousel text-center">
      <b-container class="carousel-container-text">
        <h2>Brincando Com Ciências<br />Ensino Fundamental</h2>
        <p>A nova edição de Brincando com Ciências contempla a BNCC, desenvolve todas as competências do ensino básico e as habilidades específicas da área de Ciências da Natureza.</p>
      </b-container>
      <b-container class="carousel-container-capas text-center">
        <div>
            <slick-carousel v-bind="settings">
              <div>
                <a
                  href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/brincando-com/ciencias/1/index.html"
                  target="_blank"
                >
                  <img
                    src="https://conteudos.editoradobrasil.com.br/capa/mercado/2021/brincando-com-ciencias-1-la.jpg"
                    alt
                  />
                </a>
              </div>
              <div>
                <a
                  href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/brincando-com/ciencias/2/index.html"
                  target="_blank"
                >
                  <img
                    src="https://conteudos.editoradobrasil.com.br/capa/mercado/2021/brincando-com-ciencias-2-la.jpg"
                    alt
                  />
                </a>
              </div>
              <div>
                <a
                  href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/brincando-com/ciencias/3/index.html"
                  target="_blank"
                >
                  <img
                    src="https://conteudos.editoradobrasil.com.br/capa/mercado/2021/brincando-com-ciencias-3-la.jpg"
                    alt
                  />
                </a>
              </div>
              <div>
                <a
                  href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/brincando-com/ciencias/4/index.html"
                  target="_blank"
                >
                  <img
                    src="https://conteudos.editoradobrasil.com.br/capa/mercado/2021/brincando-com-ciencias-4-la.jpg"
                    alt
                  />
                </a>
              </div>
              <div>
                <a
                  href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/brincando-com/ciencias/5/index.html"
                  target="_blank"
                >
                  <img
                    src="https://conteudos.editoradobrasil.com.br/capa/mercado/2021/brincando-com-ciencias-5-la.jpg"
                    alt
                  />
                </a>
              </div>
            </slick-carousel>
        </div>
      </b-container>
    </section>
    <section class="destaques">
      <b-container>
        <h2 class="text-center">Destaques da coleção</h2>
        <ul>
          <li>Abordagem lúdica e divertida;</li>
          <li>Linguagem simples e objetiva;</li>
          <li>Propõe um grande número de atividades - possibilitando ao aluno maior fixação do conhecimento adquirido.</li>
          <li>Mescla de forma equilibrada conteúdos tradicionais com atividades participativas, experimentais e lúdicas.</li>
          <li>Propõe atividades interdisciplinares ao longo da coleção que proporcionam um aprendizado mais amplo através de conexões com outros componentes curriculares.</li>
          <li>Disponibiliza seção inicial com atividades para a avaliação do conhecimento prévio e seção final voltada à avaliação do conhecimento adquirido no encaminhamento do volume.</li>
        </ul>
      </b-container>
    </section>
  </div>
</template>

<script>
import Header from "../../components/Header.vue";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
export default {
  name: "Ciências",
  components: {
    Header,
    "slick-carousel": VueSlickCarousel
  },
  data: () => ({
    settings: {
      lazyLoad: "ondemand",
      arrows: true,
      dots: false,
      focusOnSelect: true,
      infinite: false,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 3,
      touchThreshold: 3,
      variableWidth: true,
      responsive: [
         {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            arrows: false,
            initialSlide: 0
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false
          }
        }
      ]
    }
  }),
  props: {
    msg: String
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../../css/_colors.scss";
.page-ciencias {
  .menu {
    .menu-ef {
      background: $ciencias;
      > a {
        color: white !important;
      }
      span.menu-title::after {
        content: url("../../assets/material-keyboard-arrow-down-white.svg");
      }
    }
  }
  section.banner {
    background-color: $ciencias;
  }
  section.carousel {
    background: url("../../assets/ed-infantil/ed-infantil-bg-branco.png");
    background-repeat: no-repeat;
    background-position: top center;
    h2 {
      color: $ciencias-2;
    }
  }
  section.destaques {
    background: $ciencias-2
      url("../../assets/anos-iniciais/ciencias/bg-destaques-ciencias.png");
    background-repeat: no-repeat;
    background-position: top center;
    color: white !important;
  }
}
</style>
